import React, { createContext, useContext, useState, useEffect } from 'react';

interface LocationContextType {
    selectedLocation: any;
    setSelectedLocation: (location: any) => void;
    availableCities: any[];
    setAvailableCities: (cities: any[]) => void;
}

const LocationContext = createContext<LocationContextType | undefined>(undefined);

export const useLocation = () => {
    const context = useContext(LocationContext);
    if (context === undefined) {
        throw new Error('useLocation must be used within a LocationProvider');
    }
    return context;
};

interface LocationProviderProps {
    children: React.ReactNode;
}

export const LocationProvider: React.FC<LocationProviderProps> = ({ children }) => {
    const [selectedLocation, setSelectedLocation] = useState<any>(null);
    const [availableCities, setAvailableCities] = useState<any[]>([]);

    // Load selected location from localStorage on mount
    useEffect(() => {
        const savedLocation = localStorage.getItem('selectedLocation');
        if (savedLocation) {
            try {
                setSelectedLocation(JSON.parse(savedLocation));
            } catch (error) {
                console.error('Error parsing saved location:', error);
            }
        }
    }, []);

    // Save location to localStorage whenever it changes
    useEffect(() => {
        if (selectedLocation) {
            localStorage.setItem('selectedLocation', JSON.stringify(selectedLocation));
        }
    }, [selectedLocation]);

    const value = {
        selectedLocation,
        setSelectedLocation,
        availableCities,
        setAvailableCities,
    };

    return (
        <LocationContext.Provider value={value}>
            {children}
        </LocationContext.Provider>
    );
};
